import {Component, OnInit, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UserService} from 'projects/core/src/lib/login/data/user.service';
import {TimeCard} from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-card';
import {User} from 'projects/core/src/lib/login/data/user';
import * as moment from 'moment';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {TimeCardService} from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-card.service';
import {Project} from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import {ProjectService} from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import {MvcExceptionResponse} from 'projects/core/src/lib/core/data/mvc-exception-response';
import {TimeCardsStore} from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-cards.store';
import {ConfirmationService} from 'primeng/api';
import {MatSnackBar} from '@angular/material/snack-bar';
import {environment} from 'projects/desktop/src/environments/environment';

@Component({
  selector: 'app-timesheet-edit-dialog',
  templateUrl: './timesheet-edit-dialog.component.html',
  styleUrls: ['./timesheet-edit-dialog.component.scss'],
  providers: [ConfirmationService]
})
export class TimesheetEditDialogComponent implements OnInit {

  users: User[] = [];
  currentUser: User;
  selectedUser: User;

  jobs: Project[] = [];
  currentJob: Project;
  currentJobId: number;

  timeCard: TimeCard;

  newTime: boolean;

  startDate: Date;
  endDate: Date;
  notes: string;

  buttonLabel: string;

  loadingSpinner = false;
  deleteLoadingSpinner = false;

  breakType: string;
  breakName: string;

  sameDay: boolean;

  kioskLoading = true;

  constructor(
    protected dialogRef: MatDialogRef<TimesheetEditDialogComponent>,
    private snackBar: MatSnackBar,
    protected userService: UserService,
    protected timeCardsStore: TimeCardsStore,
    protected timeCardService: TimeCardService,
    private projectService: ProjectService,
    protected confirmationService: ConfirmationService,
    protected appStateQuery: AppStateQuery,
    @Inject(MAT_DIALOG_DATA) public data: {
      timeCard: TimeCard,
      buttonLabel: string,
      selectedUser: User,
      adminPermissions: false,
      fromKiosk: false
    }
  ) {
    this.buttonLabel = data.buttonLabel

    if (data.timeCard) {
      this.timeCard = data.timeCard

      switch (this.timeCard.type) {
        case 'WORK':
          this.breakType = 'PAID';
          this.breakName = 'Work';
          break;
        case 'PAID_BREAK':
          this.breakType = 'PAID';
          this.breakName = 'Rest';
          break;
        case 'UNPAID_VACATION':
          this.breakType = 'UNPAID';
          this.breakName = 'Lunch';
          break;
        case 'VACATION':
          this.breakType = 'VACATION';
          this.breakName = 'Vacation';
          break;
        default:
          this.breakType = 'PAID';
          this.breakName = 'Edit';
      }

      if (this.data.fromKiosk) {
        this.notes = 'Modified via SRT'

      }
    } else {
      this.breakName = 'New Time Record'
    }
  }

  ngOnInit() {
    this.appStateQuery.currentUser$.subscribe(user => {
      this.currentUser = user
    });

    this.projectService.getLastProjects().subscribe(jobs => {
      this.jobs = jobs


      if (this.timeCard && this.timeCard.job) {
        this.currentJob = this.jobs.find(job => job.id === this.timeCard.job.id)
      } else {
        this.currentJob = this.jobs[0];
      }

      if (this.currentJob) {
        this.currentJobId = this.currentJob.id
      } else {
        this.currentJobId = this.timeCard.job.id
      }
    });

    this.userService.getTrackUsers().subscribe(users => {
      this.users = users


      if (this.data.selectedUser) {
        this.selectedUser = this.users.find(user => user.id === this.data.selectedUser.id);
      } else {
        this.selectedUser = this.users.find(user => user.id === this.currentUser.id);
      }

      if (this.timeCard) {
        this.newTime = false;
        this.startDate = moment(this.timeCard.startTime).toDate();

        if (this.timeCard.finishTime) {
          this.endDate = moment(this.timeCard.finishTime).toDate();
        }

        if (this.data.fromKiosk) {
          const finishDate = moment(this.endDate)
          this.endDate = this.floorBy5Minutes(finishDate)

          this.sameDay = finishDate.isSame(this.timeCard.startTime, 'day')

          this.kioskLoading = false;
        }

      } else {
        this.newTime = true;
        this.startDate = moment().minutes(0).toDate();

      }
    })
  }

  floorBy5Minutes(momentDate): Date {
    const minutes = momentDate.minutes();
    const remainder = minutes % 5;

    momentDate.subtract(remainder, 'minutes');

    momentDate.seconds(0);
    momentDate.milliseconds(0);

    return momentDate.toDate();
  }

  saveTimeButton() {
    this.loadingSpinner = true;

    if (this.newTime) {
      this.timeCardService.createTimeCard({
        id: null,
        startTime: moment(this.startDate).format('YYYY-MM-DDTHH:mm:ss'),
        finishTime: moment(this.endDate).format('YYYY-MM-DDTHH:mm:ss'),
        notes: this.notes,
        user: {id: this.selectedUser.id},
        job: {
          id: this.currentJobId
        }
      }).subscribe(() => {


          this.loadingSpinner = false;
          this.timeCardsStore.updatePunchStatus(false);
          this.dialogRef.close();
        },
        error => {
          this.loadingSpinner = false;
          if (error instanceof MvcExceptionResponse) {
            if (error.type === 'time_card.TimeCardException') {
              this.openSnackBar(error.message)
            }
          }
        })
    } else {
      const finishTime = moment(this.endDate).format('YYYY-MM-DDTHH:mm:ss')

      const timeCardData = {
        id: this.timeCard.id,
        startTime: moment(this.startDate).format('YYYY-MM-DDTHH:mm:ss'),
        finishTime,
        notes: this.notes,
        user: this.selectedUser,
        job: {
          id: this.currentJobId
        }
      }

      let updateCard = this.timeCardService.updateTimeCard(timeCardData)

      if (this.data.adminPermissions) {
        updateCard = this.timeCardService.updateTimeCardByAdmin(timeCardData)
      }

      updateCard.subscribe(successCard => {
          if (successCard.finishTime) {
            this.timeCardsStore.updatePunchStatus(false);
            this.loadingSpinner = false;
          }

          this.dialogRef.close(successCard);
        },
        error => {
          console.error(error)

          this.loadingSpinner = false;
          if (error instanceof MvcExceptionResponse) {
            if (error.type === 'time_card.TimeCardException') {
              this.openSnackBar(error.message)
            } else {
              this.openSnackBar(environment.errorMesage)
            }
          } else {
            this.openSnackBar(environment.errorMesage)
          }
        })
    }
  }

  openSnackBar(message: string) {
    this.snackBar.open(message, '', {
      duration: 5000,
      verticalPosition: 'top',
    });
  }

  selectJobChanged(job: Project) {
    this.currentJob = job;
    this.currentJobId = job.id;
  }

  deleteTimeCard() {
    const startTime = moment(this.timeCard.startTime).format('hh:mm A')
    const finishTime = moment(this.timeCard.startTime).format('hh:mm A')
    this.confirmationService.confirm({
      message: `Delete ${startTime} - ${finishTime}?`,
      accept: () => {
        this.deleteTimeCardService();
      }
    });
  }

  deleteTimeCardService() {
    this.timeCardService.deleteTimeCard(this.timeCard.id).subscribe(() => {
        if (this.timeCard.job && !this.timeCard.finishTime) {
          this.timeCardsStore.updatePunchStatus(false)
        }
        this.deleteLoadingSpinner = false;
        this.dialogRef.close();
      },
      error => {
        this.deleteLoadingSpinner = false;
        if (error instanceof MvcExceptionResponse) {
          if (error.type === 'time_card.TimeCardException') {
            this.openSnackBar(error.message)
          }
        }
      })
  }

  blurActiveElement() {
    setTimeout(() => {
      const activeElement = document.activeElement;
      if (activeElement && activeElement instanceof HTMLElement)
        activeElement.blur()
    }, 5);
  }

}
